export default [
  {
    key: "validate.custom",
    calculateValue(context) {
      return "valid = (!input && !component.validate.required) || (input && JSON.parse(input).valid) || 'Please revise your {{component.label}}. Some of the requirements are not met.'";
    },
  },
  {
    type: "textfield",
    input: true,
    key: "customOptions.totalValue",
    weight: 10,
    label: "Total Value Requirement",
    placeholder: "Total Value Requirement",
    validate: {
      required: true,
    },
    tooltip:
      "Add two numbers with a comma (number, number) for validation with “between”. Decimal separators not allowed. Enter “no” if there are no total validation requirements.",
  },
  {
    type: "select",
    input: true,
    key: "customOptions.totalValidationRule",
    label: "Total Value Validation Rule",
    tooltip: "Select “no” if there are no total validation requirements.",
    weight: 20,
    placeholder: "Total Value Validation Rule",
    dataSrc: "values",
    validate: {
      required: true,
    },
    data: {
      values: [
        { label: "equal", value: "=" },
        { label: "less than or equal to", value: "<=" },
        { label: "greater than or equal to", value: ">=" },
        { label: "between", value: "<=, <=" },
        { label: "no", value: "no" },
      ],
    },
  },
];
